import React from 'react';
import { useSelector } from 'react-redux';
import AvaluoGracias from '../../components/AvaluoGracias';

const AvaluoGraciasContainer = () => {

  const { avaluos } = useSelector(state => ({
    avaluos: state.avaluos
  }));


  return <AvaluoGracias
    avaluos={avaluos} 
  />
};

export default AvaluoGraciasContainer
